import { render, staticRenderFns } from "./request-product-view.vue?vue&type=template&id=10aad120&scoped=true"
import script from "./request-product-view.vue?vue&type=script&lang=js"
export * from "./request-product-view.vue?vue&type=script&lang=js"
import style0 from "./request-product-view.vue?vue&type=style&index=0&id=10aad120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aad120",
  null
  
)

export default component.exports